export default {
  mounted() {
    let { title } = this.$options
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      document.title = `${title}｜Web制作会社 エヌケー・テック【福島県郡山市】`
    }
  },
  computed: {
    siteTitle() {
      let title = this.title;
      if (!this.title) {
        title = '制作実績｜Web制作会社 エヌケー・テック【福島県郡山市】'
      }
      return title
    }
  },
  watch: {
    title: function() {
      let { title } = this.$options
      if (title) {
        title = typeof title === 'function' ? title.call(this) : title
        document.title = `${title}｜Web制作会社 エヌケー・テック【福島県郡山市】`
      }
    }
  }
}
